<template>
    <div class="goodslistall" :class="{'nogoods':goodslistall.reco.length>0}">
        <div class="goodsshow">
           
            <div v-if="goodslistall.data.length>0"  v-for="(goods,index) in goodslistall.data" :key="index">
                 <user-collection-info-item :iconon="iconon" :iconoff="iconoff" itemwidth="224px" :goods="goods"  :index="(index+1)%5" :itemright="(index+1)%5==0?'0':'15px'" @editgoods="editgoods"/>
            </div>

            <div v-if="goodslistall.reco.length>0" v-for="(goods,indexs) in goodslistall.reco" :key="indexs" >
                 <user-collection-info-item :iconon="iconon" :iconoff="iconoff" itemwidth="224px" :goods="goods" :index="(indexs+1)%5" :itemright="(indexs+1)%5==0?'0':'15px'" @editgoods="editgoods"/>
            </div>

            <div class="clear"></div>
        </div>
       <div class="pageshow" v-if="showpage&&total>pagesize">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="1"
                :current-page.sync="currentPage"
                :page-size="pagesize"
                background
                layout="prev, pager, next"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>    
</template>

<script>
import UserCollectionInfoItem from './UserCollectionInfoItem.vue'
export default {
  data(){
      return{
          goodslist:{},
          currentPage:1
      }
  },
  props: {
    pagesize: {
      type: Number,
      default: 1
    },
    iconon:{
        type:String,
        default:"el-icon-delete"
    },
    iconoff:{
        type:String,
        default:"el-icon-delete"
    },
    showpage:{
        type:Boolean,
        default:true
    },
    goodslistall:{
        type:Object
    },
    total:{
        type: Number,
        default: 0
    }
  },
  components: { UserCollectionInfoItem },
  methods:{
       
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.$emit('getgoodslist',this.currentPage);  
            //this.getgoodslist();
        },
        handleSizeChange(){

        },
        editgoods(goodsid){
            this.$emit('editgoods',goodsid);      
        }
       
    }
}
</script>

<style scoped>
   
    .goodsshow{
        padding: 0 8px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/user/UserSearchGoodsList.vue